// The admin is organised in a few sections; each section is one item in the side menu and its pages
// are tabs at the top of the page (components/SectionTabs.vue). The router (router/index.js) reads
// this list to tell every page which section and tab it belongs to.
// A tab: { route: <route name>, title, icon } or { href, title, icon } for an outside link.
// `also`: other routes shown under the same tab (e.g. a ticket page under «المشاكل»).
export default [
  {
    key: 'home',
    title: 'الرئيسية',
    icon: 'HomeIcon',
    tabs: [
      { route: 'home', title: 'لوحة المتابعة', icon: 'GridIcon' },
    ],
  },
  {
    key: 'schools',
    title: 'المدارس والمبيعات',
    icon: 'BriefcaseIcon',
    tabs: [
      { route: 'users', title: 'المدارس', icon: 'UsersIcon' },
      { route: 'orders', title: 'الطلبات والمدفوعات', icon: 'ShoppingCartIcon' },
      { route: 'services', title: 'الخدمات والأسعار', icon: 'PackageIcon' },
      { route: 'enjazfile/users', title: 'ملف الإنجاز · المستخدمين', icon: 'FileIcon' },
      { route: 'enjazfile/orders', title: 'ملف الإنجاز · الطلبات', icon: 'FileTextIcon' },
    ],
  },
  {
    key: 'support',
    title: 'الدعم والتواصل',
    icon: 'LifeBuoyIcon',
    tabs: [
      { route: 'support', title: 'الدعم الفني السريع', icon: 'MessageCircleIcon' },
      { route: 'feedback2', title: 'المشاكل', icon: 'AlertTriangleIcon', also: ['ticket'] },
      { route: 'feedback1', title: 'الآراء والاقتراحات', icon: 'EditIcon' },
      { route: 'calls', title: 'مواعيد الاتصالات', icon: 'PhoneIcon' },
    ],
  },
  {
    key: 'apps',
    title: 'التطبيقات والإشعارات',
    icon: 'SmartphoneIcon',
    tabs: [
      { route: 'app-push', title: 'إشعار عام', icon: 'BellIcon' },
      { route: 'app-status', title: 'حالة تطبيق المدرسة', icon: 'SmartphoneIcon' },
      { route: 'app-messages', title: 'رسائل التطبيقات', icon: 'MessageSquareIcon' },
      { route: 'posts', title: 'الأخبار والتطويرات', icon: 'RssIcon' },
      { route: 'app-versions', title: 'الإصدارات', icon: 'LayersIcon' },
      { route: 'app-features', title: 'الخصائص', icon: 'ToggleRightIcon' },
      { route: 'app-tutorials', title: 'فيديو الشرح', icon: 'PlayCircleIcon' },
    ],
  },
  {
    key: 'partners',
    title: 'الشركاء',
    icon: 'UserCheckIcon',
    tabs: [
      { route: 'resellers', title: 'الشركاء', icon: 'UserCheckIcon' },
      { route: 'visits', title: 'الزيارات', icon: 'MapPinIcon' },
      { route: 'calendar', title: 'المواعيد', icon: 'CalendarIcon' },
      { route: 'todo', title: 'المهام', icon: 'CheckSquareIcon' },
    ],
  },
  {
    key: 'monitor',
    title: 'المراقبة',
    icon: 'ActivityIcon',
    tabs: [
      { route: 'request-stats', title: 'إحصائيات الطلبات', icon: 'ActivityIcon' },
      { route: 'error-log', title: 'سجل تصحيح الأخطاء', icon: 'AlertOctagonIcon' },
      { route: 'biotime', title: 'أجهزة البصمة', icon: 'ServerIcon' },
    ],
  },
  {
    key: 'system',
    title: 'النظام',
    icon: 'SettingsIcon',
    tabs: [
      { route: 'settings', title: 'الإعدادات', icon: 'SlidersIcon' },
      { route: 'freedays', title: 'الإجازات والعطلات', icon: 'SunIcon' },
      { route: 'new-year', title: 'تهيئة العام الجديد', icon: 'DatabaseIcon' },
      { route: 'ups', title: 'تدخل برمجي', icon: 'CodeIcon' },
      { href: 'https://tahdir.net/ShortLink.php', title: 'اختصار الروابط', icon: 'LinkIcon' },
    ],
  },
]
